import moment from 'moment';
import {
  EShakaPackagerJobStatus,
  ShakaPackagerJob,
} from '../../../../domain/media-transcoder/shaka-packager-job';

export class PackagerJobViewModel {
  readonly id: string;
  readonly mediaId: number;
  readonly mediaName: string;
  readonly jobStatus: EShakaPackagerJobStatus;
  readonly statusDisplay: string;
  readonly scheduledAt: string;
  readonly lastJobStatusUpdate: moment.Moment;
  readonly lastUpdate: string;
  readonly sourcePath: string;
  readonly hasProcessLog: boolean;

  constructor(job: ShakaPackagerJob) {
    this.id = job.jobUid;
    this.mediaId = job.mediaId;
    this.mediaName = job.mediaName;
    this.jobStatus = job.jobStatus;
    this.statusDisplay = job.statusDisplay;
    this.scheduledAt = job.createdAt.format('YYYY-MM-DD HH:mm:ss');
    this.lastJobStatusUpdate = job.lastJobStatusUpdate;
    this.lastUpdate = job.lastJobStatusUpdate.format('YYYY-MM-DD HH:mm:ss');
    this.sourcePath = job.sourcePath;
    this.hasProcessLog = job.hasProcessLog;
  }
}
